var _style, _defs, _g, _g2, _defs2, _g3, _g4, _path, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGround(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#D78555;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 110,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Grass",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "st1",
    d: "M-2,4.8c-2.5-2.5-2.5-6.6,0-9.1c1.3-1.3,4.1-2,6.2-2.3C5.6-6.8,7.1-7,8.5-7l0,0 c0.2,1.6,0.2,3.3,0.2,5c0,2.4-0.4,5.6-1.7,6.9C4.9,7,1.5,7.4-1.1,5.6l2-2.5l3.2-0.7L1.5,2.1l1.7-1.7L5.1,0L3.6-0.5l1.5-2.7L3-0.8 L2.1-1.9L2.4,0L0.9,1.7L0.2-0.5l0,2.8L-1.9,5l0,0L-2,4.8z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_3_",
    points: "106,61 -4,61 -4,31 106,31  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Ground",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_2_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st2",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.6,19c-0.4,0.4-0.9,0.8-1.6,1s-1.4,0.4-2.2,0.4c-0.9,0-1.6-0.2-2.3-0.6S35.4,19,35,18.2 c-0.4-0.7-0.5-1.6-0.5-2.5V15c0-1,0.2-1.9,0.5-2.6s0.8-1.3,1.4-1.7s1.4-0.6,2.2-0.6c1.2,0,2.1,0.3,2.8,0.8s1.1,1.4,1.2,2.5h-2 c-0.1-0.6-0.3-1-0.6-1.3s-0.7-0.4-1.3-0.4c-0.7,0-1.2,0.3-1.6,0.8S36.6,14,36.6,15v0.6c0,1,0.2,1.8,0.6,2.4s1,0.8,1.7,0.8 c0.8,0,1.3-0.2,1.6-0.5v-1.7h-1.9v-1.5h3.9V19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,16.7h-1.6v3.6h-2.1v-10H48c1.2,0,2.1,0.3,2.7,0.8c0.6,0.5,1,1.3,1,2.2c0,0.7-0.1,1.2-0.4,1.7 c-0.3,0.5-0.7,0.8-1.3,1.1l2.2,4.1v0.1h-2.2L48,16.7z M46.3,15H48c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.4-1.1c0-0.5-0.1-0.8-0.4-1.1 S48.5,12,48,12h-1.6V15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.4,15.6c0,1-0.2,1.8-0.5,2.6s-0.8,1.3-1.5,1.7c-0.6,0.4-1.4,0.6-2.2,0.6c-0.8,0-1.6-0.2-2.2-0.6 s-1.1-1-1.5-1.7s-0.5-1.6-0.5-2.5v-0.5c0-1,0.2-1.8,0.5-2.6c0.4-0.7,0.9-1.3,1.5-1.7c0.6-0.4,1.4-0.6,2.2-0.6s1.6,0.2,2.2,0.6 c0.6,0.4,1.1,1,1.5,1.7c0.4,0.7,0.5,1.6,0.5,2.6V15.6z M59.3,15.1c0-1-0.2-1.8-0.6-2.4s-0.9-0.8-1.6-0.8c-0.7,0-1.2,0.3-1.6,0.8 S55,14,55,15.1v0.5c0,1,0.2,1.8,0.6,2.4s0.9,0.8,1.6,0.8c0.7,0,1.2-0.3,1.6-0.8s0.6-1.3,0.6-2.4V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.4,10.3v6.6c0,1.1-0.3,2-1,2.6c-0.7,0.6-1.6,0.9-2.8,0.9c-1.2,0-2.1-0.3-2.8-0.9s-1-1.5-1-2.5v-6.6h2.1v6.6 c0,0.7,0.2,1.1,0.5,1.4c0.3,0.3,0.7,0.4,1.3,0.4c1.2,0,1.7-0.6,1.8-1.8v-6.6H70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.2,20.3h-2.1l-4-6.5v6.5h-2.1v-10h2.1l4,6.6v-6.6h2V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82,20.3v-10H85c0.9,0,1.7,0.2,2.3,0.6c0.7,0.4,1.2,1,1.6,1.7s0.6,1.6,0.6,2.5v0.5c0,0.9-0.2,1.7-0.6,2.5 c-0.4,0.7-0.9,1.3-1.6,1.7s-1.5,0.6-2.3,0.6H82z M84,12v6.6h1c0.8,0,1.4-0.3,1.8-0.8c0.4-0.5,0.6-1.3,0.6-2.2v-0.5 c0-1-0.2-1.8-0.6-2.3S85.8,12,85,12H84z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.6,21c-0.1,0-0.1-0.1-0.1-0.1l4-11.7c0-0.1,0.1-0.1,0.2-0.1h4.1C21,9,21,9.1,21.1,9.1L25,20.7 c0,0.1-0.1,0.3-0.2,0.3H12.6z M9.2,21C9.1,21,9,20.8,9,20.7l2.9-8c0-0.1,0.1-0.1,0.2-0.1h2.2c0.1,0,0.3,0.2,0.2,0.3l-2.8,8 c0,0.1-0.1,0.1-0.2,0.1H9.2z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGround);
export default __webpack_public_path__ + "static/media/ground.cc783303ccad45856bdc3286da97b214.svg";
export { ForwardRef as ReactComponent };